import React from 'react';
import Button from '../Button/Button';
import styles from './ActionCTA.module.css';

function ActionCTA({
  title = "Vous avez un projet similaire en tête ?",
  text = "Discutons ensemble de vos idées. Notre expertise est à votre service pour concrétiser votre vision.",
  buttonText = "Demander une consultation"
}) {
  return (
    <div className={styles.ctaContainer}>
      <div className={styles.ctaContent}>
        <span className={styles.eyebrow}>Votre Futur Projet</span>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.divider}></div>
        <p className={styles.description}>{text}</p>
        <div className={styles.buttonWrapper}>
          <Button to="/contact" variant="primary" size="large">{buttonText}</Button>
        </div>
      </div>
      <div className={styles.decoration}></div>
    </div>

  );
}

export default ActionCTA;
